import {
  FETCH_DASHBOARD_DATA_START,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  SET_LOAN_STATUS,
  SET_DOCUMENT_STATUS,
  SET_USER_DETAILS,
  SET_NOTIFICATIONS_READ,
  SET_CREDIT_MODEL,
  RESET_DASHBOARD,
} from "./types";
import { loanStatusApi, getNotification } from "../ApplyLoan/action";
import { getUserDetail, getGenralUserDetail } from "../GeneralDetails/action";
import { getDocumentStatus } from "../Manual_Kyc_Details/action";

const getCreditIndex = (userCredit) => {
  let status = "";
  let index = 0;
  let credit_limit = 0;

  for (let i = 0; i <= userCredit?.length; i++) {
    if (userCredit?.[i]?.loan_type !== "P") {
      status = "E";
      if (userCredit?.[i]?.credit_limit > credit_limit) {
        index = i;
        credit_limit = userCredit?.[i]?.credit_limit;
      }
    } else {
      if (status !== "E") {
        index = i;
      }
    }
  }
  return index;
};

export const fetchDashboardData = (token) => async (dispatch) => {
  dispatch({ type: FETCH_DASHBOARD_DATA_START });

  try {
    await Promise.all([
      dispatch(fetchDocumentStatus(token)),
      dispatch(fetchUserDetails(token)),
      dispatch(fetchLoanStatus(token)),
      dispatch(fetchNotifications(token)),
    ]);

    dispatch({ type: FETCH_DASHBOARD_DATA_SUCCESS });
  } catch (error) {
    dispatch({
      type: FETCH_DASHBOARD_DATA_FAILURE,
      payload: error?.message || "Failed to fetch dashboard data",
    });
  }
};

export const fetchDocumentStatus = (token) => async (dispatch) => {
  try {
    const res = await dispatch(getDocumentStatus(token));
    const data = res?.data?.[0];

    if (!data?.cibil_form && data?.blocked) {
      localStorage.setItem("cibilfalsenblocked", data?.blocked);
    }
    localStorage.setItem("user_type", data?.user_type);
    localStorage.setItem("can_apply", data?.can_apply_for_loan);
    localStorage.setItem("blocked", data?.blocked);
    localStorage.setItem("axiscard", data?.axis_card);
    localStorage.setItem("apply", data?.can_apply_for_loan);

    dispatch({
      type: SET_DOCUMENT_STATUS,
      payload: {
        documentStatus: data || {},
        blocked: data?.blocked || false,
        cibilFlow: data?.cibil_flow || "",
      },
    });

    return data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("gpay_token");
    }
    throw error;
  }
};

export const fetchUserDetails = (token) => async (dispatch) => {
  try {
    const res = await dispatch(getUserDetail(token));
    const list = res?.data?.data;
    const userCredit = list?.customusermodel?.usercredit || [];
    const idx = getCreditIndex(userCredit);

    let paydayAmount = 0;
    let emiAmount = 0;

    if (userCredit?.length > 0) {
      userCredit.forEach((credit) => {
        if (credit.loan_type === "P") {
          localStorage.setItem("paydayAmount", credit?.credit_limit);
          localStorage.setItem("P", credit?.loan_type);
          paydayAmount = credit?.credit_limit;
        } else {
          if (credit?.credit_limit > emiAmount) {
            emiAmount = credit?.credit_limit;
          }
          localStorage.setItem("emiAmount", emiAmount);
          localStorage.setItem("E", credit?.loan_type);
        }
      });
    }

    localStorage.setItem("credit_amount", userCredit?.[idx]?.credit_limit);
    localStorage.setItem("credit_model", userCredit?.[idx]);
    localStorage.setItem("loan_type", userCredit?.[idx]?.loan_type);

    dispatch({
      type: SET_USER_DETAILS,
      payload: {
        userDetails: list?.customusermodel || {},
        credit: userCredit,
        creditModel: userCredit?.[idx] || {},
        canApplyForLoan: list?.customusermodel?.can_apply_for_loan || false,
        paydayAmount,
        emiAmount,
      },
    });

    return list;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("gpay_token");
    }
    throw error;
  }
};

export const fetchLoanStatus = (token) => async (dispatch) => {
  try {
    const res = await dispatch(loanStatusApi({}, token));
    const dataArray = res?.data?.data || [];
    const data = dataArray?.[0];
    const hasLoanData = dataArray?.length > 0;

    localStorage.setItem("nbfcName", data?.applied_nbfc_name || "");

    dispatch({
      type: SET_LOAN_STATUS,
      payload: {
        loanStatus: data || {},
        precloserShow: data?.preclosure_loan || false,
        hasLoanData: hasLoanData,
      },
    });

    return { data, hasLoanData };
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("gpay_token");
    }
    throw error;
  }
};

export const fetchNotifications = (token) => async (dispatch) => {
  try {
    const res = await dispatch(getNotification(token));
    const allRead = res?.data?.every((notification) => notification?.read === true);

    dispatch({
      type: SET_NOTIFICATIONS_READ,
      payload: allRead,
    });

    return allRead;
  } catch (error) {
    throw error;
  }
};

export const setCreditModel = (creditModel) => ({
  type: SET_CREDIT_MODEL,
  payload: creditModel,
});

export const resetDashboard = () => ({
  type: RESET_DASHBOARD,
});
